export enum AdminTypes {
    login = '[auth] Login',
    logout= '[auth] Logout',
    updatePermisos = '[auth] Update Permisos',
};